import {templates} from 'features/beersManager/typescript';

export const getTemplateId = (template: templates) => {
  const templateIdObject: {[key in keyof typeof templates]: number} = {
    [templates.Standard]: 0,
    [templates.Standard2]: 1,
  };

  return templateIdObject[template] || 0;
};
